import { cva } from 'class-variance-authority';

/** Warianty etykiety statusu. Osobny plik ze wzgledu na fast refresh. */
export const badgeVariants = cva(
  'inline-flex shrink-0 items-center gap-1.5 font-semibold whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-sunken text-fg-muted border border-border-strong',
        brand: 'bg-brand-subtle text-brand-text border border-brand-200',
        success: 'bg-success-50 text-success-700 border border-success-100',
        warning: 'bg-warning-50 text-warning-700 border border-warning-100',
        danger: 'bg-danger-50 text-danger-700 border border-danger-100',
        info: 'bg-info-50 text-info-700 border border-info-100',
        /** Pelne wypelnienie kolorem marki — mocny akcent, np. aktywna zakladka. */
        solid: 'bg-brand text-fg-on-brand border border-brand',
      },
      size: {
        sm: 'h-5 rounded-full px-2 text-[0.6875rem]',
        md: 'h-6 rounded-full px-2.5 text-xs',
        lg: 'h-7 rounded-full px-3 text-[0.8125rem]',
      },
      /** Kwadratowy wariant do numerow rozstawienia w tabeli zawodnikow. */
      shape: {
        pill: '',
        square: 'aspect-square justify-center rounded-md px-0',
      },
    },
    defaultVariants: {
      tone: 'neutral',
      size: 'md',
      shape: 'pill',
    },
  },
);
